import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "./isAuthenticated";

export default function RedirectIfAuth({
  children,
  to = "/config",
}: {
  children: React.ReactNode;
  to?: string;
  requiredRole?: string;
}) {
  const location = useLocation();
  const state = location.state as any;

  const fallback: string =
    (typeof state?.from === "string" && state.from) ||
    (typeof state?.from?.pathname === "string" && state.from.pathname) ||
    to;
    
  return isAuthenticated() ? (
    <Navigate to={fallback} replace />
  ) : (
    <>{children}</>
  );
}
